import { ChipGroup as ChipGroupSchema } from '@/schemas/sceneDataSchema';
import { UseFormReturn, Controller } from 'react-hook-form';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { FormValues } from '@/constants/formTypes';
import { BaseChipElement } from './BaseChipElement';

export const ChipFormElement = ({
  form,
  component,
}: {
  form: UseFormReturn<FormValues>;
  component: ChipGroupSchema;
}) => {
  return (
    <Controller
      name={encodeFieldKey(component)}
      control={form.control}
      render={({ field: { onChange, value } }) => (
        <BaseChipElement
          onChange={onChange}
          options={component.options}
          value={value}
        />
      )}
    />
  );
};
